export default __webpack_public_path__ + "static/media/tm6.e80766a0.webp";